import { i18n }  from '@/main';


export const ui = {
    namespaced: true,
    state: {
        registerModalOpen: false,
        passwordForgetModalOpen: false,
        contactUsModalOpen: false,
        allLanguages: [
            
            { key: 'de', value: 'Deutsch' },
            { key: 'dk', value: 'Dansk' },
            { key: 'en', value: 'English' },
            { key: 'es', value: 'Español' },
            { key: 'fi', value: 'Suomi'},
            { key: 'fr', value: 'Français' },
            { key: 'gr', value: 'ελληνικά' },
            { key: 'it', value: 'Italiano' },
            { key: 'nl', value: 'Nederlands' },
            { key: 'no', value: 'Norsk' },
            { key: 'pt', value: 'Português' },
            { key: 'ru', value: 'Pусский' },
            { key: 'se', value: 'Svenska' },
            { key: 'ua', value: 'Yкраїнська мова' },

            // CEE countries
            { key: 'pl', value: 'Polski' },
            { key: 'cz', value: 'Čeština' },
            { key: 'hu', value: 'Magyar' },
            { key: 'sk', value: 'slovenský' },
            { key: 'ro', value: 'Română' }
        ],
        availableLanguages: [
            'de','dk','en','es','fi','fr','gr','it','nl','no', 'pt','ru','se','ua',

            // CEE countries
            'cz', 'pl', 'hu', 'sk', 'ro'
        ],
        currentLanguage: { key: 'en', value: 'English' },
        defaultOpenFilter: "",
    },

    mutations: {
        registerModalOpen(state, value) { state.registerModalOpen = value; },
        passwordForgetModalOpen(state, value) { state.passwordForgetModalOpen = value; },
        contactUsModalOpen(state, value) { state.contactUsModalOpen = value; },

        // Called responsible for sanitizing the list of values.
        availableLanguages(state, values) {
            state.availableLanguages = values;
        },

        // Takes a language code
        currentLanguage(state, value) {
            if (!state.availableLanguages.includes(value)) {
                // Fallback to english if language not available
                value = 'en';
            }

            const l = state.allLanguages.find((v) => v.key === value);
            if (l !== undefined) {
                state.currentLanguage = l;
                i18n.locale = l.key;
                return;
            }

            // Always fall back to english
            state.currentLanguage = state.allLanguages.find((v) => v.key === "en");
            i18n.locale = "en";
            
        },
        
        defaultOpenFilter(state, value) {
            state.defaultOpenFilter = value;
        }
    },

    getters: {
        availableLanguageData(state) {
            return state.allLanguages.filter((v) => state.availableLanguages.includes(v.key));
        },

        currentLanguage(state) {
            return state.currentLanguage;
        },

        defaultOpenFilter(state) {
            return state.defaultOpenFilter;
        }
    },

    methods: {
        getCurrentLanguage() {
            return this.currentLanguage;
        },

        // Returns an array of language objects instead of just language codes
        getAvailableLanguages() {
            return this.allLanguages.filter((v) => this.availableLanguages.includes(v.key));
        }
    },

    actions: {
        showToast({commit}, {type, message}) {
            this._vm.$snotify[type](i18n.t(message));
        },

        sanitizeLanguage({state, commit}) {
            if (!state.availableLanguages.includes(state.currentLanguage.key))
                commit("currentLanguage", state.availableLanguages[0]);
        }
    }
};
